export const GET_SINGLE_PROGRAM = `
  query getProgramByUid($uid: String!) {
    getProgramByUid(uid: $uid) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          ...ProgramFragmentFields
        }
        cast {
          ...RoleArtistFragmentFields
        }
        categories {
          ...TagFragmentFields
        }
        genres {
          ...TagFragmentFields
        }
        seasons {
          ...SeasonFragmentFields
        }
        solitaryEpisode {
          ...EpisodeFragmentFields
        }
        trailers {
          ...PlayableTrailerFragmentFields
        }
      }
    }
  }
  fragment StatusFragmentFields on Status {
    message
    statusCode
  }
  fragment ProgramFragmentFields on Program {
    id
    uid
    bannerImagePath
    description
    descriptionEnglish
    isBookMarkedByMe
    isExclusive
    isSolitary
    landscapeImagePath
    originalLanguageId
    playType
    portraitImagePath
    productionYear
    summary
    summaryEnglish
    title
    titleEnglish
    typoGraphyImagePath
    parentalGuidance
    interestDetails {
      interestedByUser
    }
    statisticsDetails {
      totalDislikePercentage
      totalLikePercentage
      totalLovePercentage
      totalInterestCount
    }
    genres {
      ...TagFragmentFields
    }
  }
  fragment TagFragmentFields on Tag {
    id
    descriptor
    name
    landscapeImagePath
    portraitImagePath
    descriptor
  }
  fragment RoleArtistFragmentFields on RoleArtist {
    artists {
      bannerImagePath
      biography
      descriptor
      fullName
      id
      imagePath
    }
    name
    role
  }
  fragment SeasonFragmentFields on Season {
    description
    descriptionEnglish
    id
    landscapeImagePath
    portraitImagePath
    productionYear
    programId
    summary
    summaryEnglish
    title
    titleEnglish
  }
  fragment EpisodeFragmentFields on Episode {
    id
    accessType
    description
    descriptionEnglish
    duration
    landscapeImagePath
    order
    playLinkURI
    portraitImagePath
    programID
    releaseDate
    releaseStatus
    seasonID
    status
    summary
    summaryEnglish
    title
    titleEnglish
    uid
    whitelistedIsps {
      name
      descriptor
    }
  }
  fragment PlayableTrailerFragmentFields on PlayableTrailer {
    coverImagePath
    id
    isDefault
    metadata
    playLinkURI
    playLinkURL
    size
    title
    videoPath
    subtitleMetadata {
      url
      label
      direction
      langCode
    }
  }
`;

export const GET_SINGLE_PROGRAM_BY_ID = `
query getProgramById($id: String!) {
    getProgram(id: $id) {
      status {
        ...StatusFragmentFields
      }
      data {
        program {
          ...ProgramFragmentFields
        }
        cast {
          ...RoleArtistFragmentFields
        }
        categories {
          ...TagFragmentFields
        }
        genres {
          ...TagFragmentFields
        }
        seasons {
          ...SeasonFragmentFields
        }
        solitaryEpisode {
          ...EpisodeFragmentFields
        }
        trailers {
          ...PlayableTrailerFragmentFields
        }
      }
    }
  }
  fragment StatusFragmentFields on Status {
    message
    statusCode
  }
  fragment ProgramFragmentFields on Program {
    id
    uid
    bannerImagePath
    description
    descriptionEnglish
    isBookMarkedByMe
    isExclusive
    isSolitary
    landscapeImagePath
    originalLanguageId
    playType
    portraitImagePath
    productionYear
    summary
    summaryEnglish
    title
    titleEnglish
    typoGraphyImagePath
    parentalGuidance
    interestDetails {
      interestedByUser
    }
    statisticsDetails {
      totalDislikePercentage
      totalLikePercentage
      totalLovePercentage
      totalInterestCount
    }
    genres {
      ...TagFragmentFields
    }
  }
  fragment TagFragmentFields on Tag {
    id
    descriptor
    name
    landscapeImagePath
    portraitImagePath
    descriptor
  }
  fragment RoleArtistFragmentFields on RoleArtist {
    artists {
      bannerImagePath
      biography
      descriptor
      fullName
      id
      imagePath
    }
    name
    role
  }
  fragment SeasonFragmentFields on Season {
    description
    descriptionEnglish
    id
    landscapeImagePath
    portraitImagePath
    productionYear
    programId
    summary
    summaryEnglish
    title
    titleEnglish
  }
  fragment EpisodeFragmentFields on Episode {
    id
    accessType
    description
    descriptionEnglish
    duration
    landscapeImagePath
    order
    playLinkURI
    portraitImagePath
    programID
    releaseDate
    releaseStatus
    seasonID
    status
    summary
    summaryEnglish
    title
    titleEnglish
    uid
    whitelistedIsps {
      name
      descriptor
    }
  }
  fragment PlayableTrailerFragmentFields on PlayableTrailer {
    coverImagePath
    id
    isDefault
    metadata
    playLinkURI
    playLinkURL
    size
    title
    videoPath
    subtitleMetadata {
      url
      label
      direction
      langCode
    }
  }`;

export const GET_SEASON_EPISODES = `
  query getSeasonEpisodes($seasonId: String!) {
    getSeasonEpisodes(seasonID: $seasonId) {
      status {
        message
        statusCode
      }
      data {
        uid
        id
        title
        titleEnglish
        summary
        summaryEnglish
        description
        descriptionEnglish
        landscapeImagePath
        portraitImagePath
        order
        duration
        releaseDate
        releaseStatus
      }
    }
  }
`;

export const ADD_INTEREST = `
  mutation addInterest($intType: InterestType!, $itemID: String!, $action: InterestAction!) {
    addInterest(intType: $intType, itemID: $itemID, action: $action) {
      status {
        statusCode
        message
      }
      data {
        id
        type
        itemId
        userId
        action
      }
    }
  }
`;
